import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Box from "@mui/material/Box";
import { NavStyles as styles } from "./MainNav.styles"
import { useLocation } from "react-router-dom";


/**
 * Block used as a side main navigation.
 * @param {JSX.Element} children - The navigation bar elements.
 * @returns {JSX.Element}
 */
const MainNav = ({children}) => {
  const [menuActive, setMenuActive] = useState(false);
  const [scroll, setScroll] = useState(false);

  const location = useLocation();

  /**
   * This useEffect is required to hide the menu when the pathname do not change but the query is removed.
   * This happen with saved boards/groups comparing the location object always return true.
   * TODO explore to share the hook to the mainNav content component. Perhaps using and store.
   **/
  useEffect(()=>{
      setMenuActive(false)
  },[location.key])

  useEffect(() => {
      // Updating menu class onScroll position.
      function scrollBehavior() {
        let windowPosition = window.scrollY;
        if (windowPosition > 58) {
          setScroll(true);
        } else {
          setScroll(false);
        }
      }
      // Menu button behavior on scroll.
      window.addEventListener('scroll', scrollBehavior);

      // Cleaning up listener.
      return function cleanupListener() {
        window.removeEventListener('scroll', scrollBehavior)
      }

    }, [menuActive]);



    return (
      <Box className={"MainNav"} sx={styles}>
        {menuActive && <div className="MainNav__overlay"></div>}
        <button
          className={`button__toggle-menu ${menuActive ? "close" : "open"} ${
            scroll ? "on-scroll" : "on-top"
          }`}
          onClick={() => setMenuActive(!menuActive)}
        >
          {menuActive ? (
            <CloseRoundedIcon
              className={"toggle-menu__icon"}
              style={{ fontSize: 35, color: "#FFF" }}
            />
          ) : (
            <MenuRoundedIcon
              className={`toggle-menu__icon`}
              style={{ fontSize: 50 }}
            />
          )}
        </button>
        <nav
          className={`MainNav__menu ${
            menuActive ? "menu--active" : "menu--hide"
          }`}
        >
          {children}
        </nav>
      </Box>
    );
}

MainNav.propTypes = {
  children: PropTypes.element.isRequired,
}

export default React.memo(MainNav);


